module.exports = __webpack_public_path__ + "img/h-tit.49b4c14a.png";